import CryptoJS from 'crypto-js'

export default class Crypto {
  // aes加密
  aesEncrypt (key, string) {
    let iv = CryptoJS.enc.Latin1.parse(key)
    let encrypted = CryptoJS.AES.encrypt(string, iv, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  }
  // aes解密
  aesDecrypt (key, string) {
    let iv = CryptoJS.enc.Latin1.parse(key)
    let decrypted = CryptoJS.AES.decrypt(string, iv, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
  }
  // 获取md5
  getMD5 (value) {
    return CryptoJS.MD5(value).toString().substr(8, 16)
  }
}



// WEBPACK FOOTER //
// ./src/new-login-2018/common/Crypto.js